<div class="leader-board-card-list fx-column fx-start-stretch">
	<!-- <div class="leader-board-card-item  fx-row fx-start-center fx-grow fx-shrink"
		[ngClass]="(leaderCard?.background) ? 'bordered-bg' : ''"> -->
		<div class="leader-board-card-item  fx-row fx-start-center fx-grow fx-shrink">
		<div class="leader-board-left-block">
			<div class="thumbnail-block">
				<img class="img cursor-pointer" [src]="leaderCard?.userThumbnail"
					(error)="gfService.setErrorImage($event, 'man')" alt="">
			</div>
			<div class="patch-block">
				<ng-container *ngIf="leaderCard?.ratingType === 'capsule'">
					<p class="chip-patch fx-center-center">
						<span>{{ leaderCard?.rank }}</span>
					</p>
				</ng-container>
				<ng-container *ngIf="leaderCard?.ratingType === 'round'">
					<p class="count-patch">
						<mat-icon svgIcon="shield-new"></mat-icon>
						<span class="rank-info">{{ leaderCard?.rank }}</span>
					</p>
				</ng-container>
			</div>

			<div class="ranking-batch" [ngClass]="{'gold': leaderCard?.badge === 'gold',
			 'platinum': leaderCard?.badge === 'platinum', 'silver': leaderCard?.badge === 'silver',
			 'bronze': leaderCard?.badge === 'bronze', 'starter': leaderCard?.badge === 'starter'}">
				<ng-container *ngIf="leaderCard?.badge !== 'starter'">
					<mat-icon svgIcon="star-badge" class="star-icon"></mat-icon>
				</ng-container>
				<ng-container *ngIf="leaderCard?.badge === 'starter'">
					<mat-icon svgIcon="star-badge-outline" class="star-icon"></mat-icon>
				</ng-container>
			</div>
		</div>
		<div class="board-right-block fx-column fx-start-start fx-grow fx-shrink">
			<!-- <p class="sub-caption-1"
				[innerHtml]="locale.translate('points_count') | handleBar : {'count': leaderCard?.points | count}"></p> -->
			<p class="user-name cursor-pointer" (click)="info()">
				{{leaderCard?.title}}</p>
			<div class="short-info fx-grow fx-shrink">
				<ng-container *ngFor="let info of leaderCard?.shortInfo; let index = index">
					<span class="short-info-caption">{{info?.value}}</span>
					<ng-container *ngIf="index !== (leaderCard?.shortInfo?.length - 1)">
						<span>|</span>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</div>
</div>
